import React from "react";
import { Box } from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import {customerDetailsFilters} from "../../@signals";

export default function nameColumn() {
    return {
        name: 'name', label: 'Customer Name',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: (value, row) => <Box>
                {value}
                <IconSeeker
                    icon="circle-info"
                    tooltip="View customer details"
                    sx={{ ml: 1, fontSize: '1rem', cursor: 'pointer'  }}
                    onClick={() => {
                        customerDetailsFilters.value = row
                    }}
                />
            </Box>
        }
    }
}